import Logo from "@/components/Logo";
import { PHONES, EMAIL, HOURS, LOCATION, NAV_LINKS } from "@/lib/site";

const FOOTER_LINKS = NAV_LINKS.filter((l) => l.href !== "#home");

export default function Footer() {
  return (
    <footer className="bg-ink text-cream grain relative" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-8 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr] gap-12 pb-16 border-b border-white/10">
          <div>
            <Logo dark />
            <p className="font-serif italic text-xl text-cream/80 mt-6">Make Your Dream Home Reality</p>
            <p className="mt-4 text-sm leading-relaxed text-cream/55 max-w-sm">
              Custom home design, architectural drafting, approvals and end-to-end building across
              Tarneit, Melbourne's west and Victoria.
            </p>
          </div>

          <nav aria-label="Footer">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-5">Navigate</p>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-cream/75 hover:text-arcblue transition-colors duration-300 text-sm"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              {PHONES.map((p) => (
                <li key={p.tel}>
                  <a href={`tel:${p.tel}`} data-testid={`footer-phone-${p.tel}`} className="text-cream/75 hover:text-arcblue transition-colors duration-300">
                    {p.display}
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="text-cream/75 hover:text-arcblue transition-colors duration-300 break-all">
                  {EMAIL}
                </a>
              </li>
              <li className="text-cream/55 pt-2">
                {HOURS.days}
                <br />
                {HOURS.time}
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-5">Location</p>
            <p className="text-cream/75 text-sm leading-relaxed">
              {LOCATION.line1}
              <br />
              {LOCATION.line2}
            </p>
            <a
              href={LOCATION.directions}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-get-directions"
              className="inline-block mt-4 text-sky border-b border-arcblue/50 pb-0.5 text-sm hover:text-cream transition-colors"
            >
              Get Directions
            </a>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-xs text-cream/45">
          <p data-testid="footer-copyright">© 2026 ArcView Homes. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="/privacy" data-testid="footer-privacy-link" className="hover:text-arcblue transition-colors">Privacy Policy</a>
            <a href="/terms" data-testid="footer-terms-link" className="hover:text-arcblue transition-colors">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
